module.exports = {"phase":"INTRO","totalSeasons":1,"totalRaces":3,"season":1,"race":1,"finished":false}


//////////////////
// WEBPACK FOOTER
// ./src/data/mocks/intro.json
// module id = ./src/data/mocks/intro.json
// module chunks = 0